import { Affix, Button, Card, Form, Space, message } from "antd";
import { LIEN_COST_LIST_ENDPOINT } from "apiServices/API_ENDPOINTS";
import { getData } from "apiServices/common";
import HandleNotification from "common/Notification";
import { isMobileView } from "components/Common/AppHelper";
import Header from "components/Common/Header";
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import LienCostForm from "../LienCostForm";

const UpdateLienCost = (props) => {
  const { width, viewMode } = props;
  const [editInfo, setEditInfo] = useState([]);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { lienCostId } = useParams();

  const getLienCostInfo = useCallback(
    async (id) => {
      const query = `${LIEN_COST_LIST_ENDPOINT}/${id}`;
      const response = await getData(query);

      if (response && response?.data?.code === 200) {
        const lienCostData = response?.data?.data;
        form.setFieldsValue({
          name: lienCostData?.name,
          description: lienCostData?.description,
        });
        setEditInfo(lienCostData);
      } else {
        HandleNotification(
          "error",
          "Error!",
          response?.message || "Failed to get lien cost data",
        );
      }
    },
    [form],
  );

  useEffect(() => {
    if (lienCostId) {
      getLienCostInfo(lienCostId);
    }
  }, [lienCostId, getLienCostInfo]);

  const discardForm = () => {
    navigate("/import-export-expense-tracking/lien-cost");
  };

  const updateLienCost = () => {
    form.submit();
  };

  const handleDownload = () => {
    if (editInfo?.voucher) {
      // Create a temporary link element to trigger download
      const link = document.createElement("a");
      link.href = editInfo.voucher;
      link.download = `lien-cost-voucher-${lienCostId}`;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      message.success("Download started");
    } else {
      message.error("No file available for download");
    }
  };

  const handlePrint = () => {
    if (editInfo?.voucher) {
      try {
        // Use the actual voucher URL from editInfo
        const pdfUrl =
          "http://localhost:4016/storage/style_document/nandy_da_inv_d&g_1756961733.pdf";

        // Open PDF in new window/tab for printing
        const printWindow = window.open(
          pdfUrl,
          "_blank",
          "width=800,height=600",
        );

        if (printWindow) {
          // Wait a moment for the PDF to load, then show print instructions
          setTimeout(() => {
            message.info({
              content:
                "PDF opened in new tab. Use Ctrl+P (or Cmd+P on Mac) to print.",
              duration: 5,
            });
          }, 1000);

          // Focus the new window
          printWindow.focus();
        } else {
          message.error(
            "Unable to open PDF. Please check your popup blocker settings.",
          );
        }
      } catch (error) {
        console.error("Print error:", error);
        message.error("Print functionality is not available");
      }
    } else {
      message.error("No file available for printing");
    }
  };

  const ActionUI = () => {
    return (
      <Space>
        {/* {viewMode && editInfo?.voucher && (
          <>
            <Button
              size="small"
              icon={<DownloadOutlined />}
              onClick={handleDownload}
              type="default"
            >
              Download
            </Button>
            <Button
              size="small"
              icon={<PrinterOutlined />}
              onClick={handlePrint}
              type="default"
            >
              Print
            </Button>
          </>
        )} */}

        <Button size="small" key={1} danger onClick={() => discardForm()}>
          {viewMode ? "Back" : "Discard"}
        </Button>

        <Button
          size="small"
          key={2}
          type="primary"
          onClick={() => updateLienCost()}
          hidden={viewMode}
        >
          Update Lien Cost
        </Button>
      </Space>
    );
  };

  return (
    <>
      <Affix offsetTop={0}>
        <Card
          className="p-fixed"
          style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}
        >
          <Header
            title={`${viewMode ? "View" : "Edit"} Lien Cost`}
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={<ActionUI />}
          />
        </Card>
      </Affix>

      <LienCostForm
        form={form}
        isEdit={true}
        viewMode={viewMode}
        editInfo={editInfo}
      />
    </>
  );
};

export default UpdateLienCost;
